import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { showImportFabricatorPopup } from './../../actions/A_Popups';
import { importFabricator, importFabricatorsZip } from './../../actions/fabricator';
import { getFabricators, getFabricatorList } from './FabricatorsActions';

import template from './importPopup.rt';

const mapStateToProps = state => {
  const { fabricators, auth } = state;
  return {
    searchKeyword: fabricators.searchKeyword,
    page: fabricators.data.page
  }
};

const mapDispatchToProps = dispatch => ({
  showImportFabricatorPopup: show => dispatch(showImportFabricatorPopup(show)),
  importFabricator: data => dispatch(importFabricator(data)),
  importFabricatorsZip: data => dispatch(importFabricatorsZip(data)),
  getFabricators: (page, limit, searchKeyword) => dispatch(getFabricators(page, limit, searchKeyword))
});

class ImportPopupClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blankFabricator: true,
      cloneFabricator: false,
      zipsOnly: false,
      fabricatorsZip: false,
      importing: false,
      fabricators: []
    }
  }

  componentDidMount() {
    getFabricatorList().then(fabs => {
      let fabricators = _.map(fabs, f => ({
        text: f.name,
        value: f.id
      }));
      let selected = _.first(fabricators);
      let selectedValue = null;
      if (selected && selected.value) {
        selectedValue = selected.value;
      }
      this.setState({ fabricators, selectedFabricator: selectedValue });
    });
  }

  getItemByValue = (value) => {
    let item = this.state.fabricators.filter(f => f.value == value);
    if (item && item.length > 0) {
      return item[0];
    }
    return null;
  }

  getSelected = () => {
    return this.getItemByValue(this.state.selectedFabricator);
  }

  getSelectedText = () => {
    let selected = this.getSelected();
    return (selected && selected.text) || "Select an Option";
  }

  getFabricatorOptions = () => {
    return [
      { text: "Do not Clone for New Fabricators", value: 'blankFabricator', selected: this.state.blankFabricator },
      { text: "Clone from Existing Fabricator for New", value: 'cloneFabricator', selected: this.state.cloneFabricator },
      { text: "Import Zips Only", value: 'zipsOnly', selected: this.state.zipsOnly },
      { text: "Import Fabricators Zip file", value: 'fabricatorsZip', selected: this.state.fabricatorsZip }
    ];
  }

  handleOption = (value) => {
    this.setState({ ...this.state, blankFabricator: false, cloneFabricator: false, [value.value]: true });
  }

  handleImport = () => {
    if (this.state.importing)
      return;
    this.setState({ ...this.state, importing: true }, async () => {
      let fileList = this.fileUploadRef.files;

      if (this.state.fabricatorsZip) {
        const fileData = new Blob([fileList[0]]);
        var fd = new FormData();
        fd.append('data', fileData, fileList[0].name);

        await this.props.importFabricatorsZip(fd);
        this.setState({ ...this.state, importing: false })
      } else {
        let read = new FileReader();
        read.onloadend = () => {
          this.props.importFabricator({ clone: this.state.cloneFabricator, zipsOnly: this.state.zipsOnly, cloneId: this.state.selectedFabricator, csv: read.result }).then(this.handleCancel);
        }
        if (fileList[0]) {
          let file = fileList[0];
          read.readAsText(file);
        }
        this.setState({ importing: false });
      }
    });
  }

  handleCancel = () => {
    this.props.showImportFabricatorPopup(false);
    this.props.getFabricators(this.props.page, 50, this.props.searchKeyword);
  }

  render = template;

}

ImportPopupClass.propTypes = {

};

const connector = connect(mapStateToProps, mapDispatchToProps);
const ImportPopup = connector(ImportPopupClass);

export default ImportPopup;
export { ImportPopup };

